import { Button, Card, Space, Table, Tag, Typography } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";

import { Context } from "../../../context";
import { Fetch } from "../../../fetch";
import { useBank } from "./BankContext";

const { Column } = Table;
const { Text } = Typography;

/** Per-level funnel + suspect questions (accuracy extremes usually mean a
 * wrong answer key or a trivial question — fix or retire in Review). */
const StatsTab = () => {
  const { token, apiUrl } = useContext(Context);
  const { configKey } = useBank();

  const [levels, setLevels] = useState([]);
  const [flagged, setFlagged] = useState([]);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    Fetch(`${apiUrl}/v4/quiz-config/stats?configKey=${configKey}`, token, (result) => {
      if (result && result.success) {
        setLevels(result.levels || []);
        setFlagged(result.flagged || []);
      }
    });
  }, [apiUrl, token, counter, configKey]);

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Card
        title="Per-level funnel"
        size="small"
        extra={
          <Button
            size="small"
            icon={<ReloadOutlined />}
            onClick={() => setCounter((n) => n + 1)}
          >
            Refresh
          </Button>
        }
      >
        <Table
          dataSource={levels.map((l) => ({ ...l, key: l.level }))}
          pagination={false}
          size="small"
        >
          <Column title="Level" dataIndex="level" width={70} />
          <Column
            title="Approved pool"
            width={120}
            render={(_, r) => (r.questions || {}).approved || 0}
          />
          <Column
            title="Drafts"
            width={90}
            render={(_, r) => (r.questions || {}).draft || 0}
          />
          <Column
            title="Passed"
            width={90}
            render={(_, r) => (r.attempts || {}).passed || 0}
          />
          <Column
            title="Failed"
            width={90}
            render={(_, r) => (r.attempts || {}).failed || 0}
          />
          <Column
            title="Abandoned / expired"
            width={150}
            render={(_, r) =>
              ((r.attempts || {}).abandoned || 0) + ((r.attempts || {}).expired || 0)
            }
          />
          <Column
            title="Pass rate"
            width={100}
            render={(_, r) => (r.passRate == null ? "-" : `${r.passRate}%`)}
          />
          <Column
            title="Coins paid"
            width={110}
            render={(_, r) => <Tag color="gold">{r.coinsPaid || 0}</Tag>}
          />
        </Table>
      </Card>

      <Card title="Flagged questions (accuracy ≤15% or ≥98%, served ≥20)" size="small">
        <Table
          dataSource={flagged.map((q) => ({ ...q, key: q._id }))}
          pagination={false}
          size="small"
        >
          <Column title="Level" dataIndex="level" width={70} />
          <Column title="Type" dataIndex="type" width={110} />
          <Column title="Question (Hindi)" dataIndex="question_hi" ellipsis />
          <Column
            title="Served"
            width={90}
            render={(_, r) => (r.stats || {}).served || 0}
          />
          <Column
            title="Accuracy"
            width={110}
            render={(_, r) =>
              r.accuracy == null ? (
                "-"
              ) : (
                <Text type={r.accuracy <= 0.15 ? "danger" : "warning"}>
                  {Math.round(r.accuracy * 100)}%
                </Text>
              )
            }
          />
        </Table>
        <div style={{ marginTop: 8 }}>
          <Text type="secondary">
            Very low accuracy usually means a wrong answer key; very high means
            the question is trivial. Edit or retire them in the Review tab.
          </Text>
        </div>
      </Card>
    </Space>
  );
};

export default StatsTab;
